export const env = {
  apiUrl: import.meta.env.VITE_API_URL as string,
  azureClientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
  azureTenantId: import.meta.env.VITE_AZURE_TENANT_ID as string,
  azureRedirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI as string,
} as const;
